module.exports = __webpack_public_path__ + "img/icon-differentials2_06.106b950e.svg";